import React, { useContext, useEffect, useState } from 'react'
import styles from './styles.module.css'
import { useDispatch } from 'react-redux'
import { Input } from '../../../../components/ModalInputs'
import CustomSelect from '../../../../components/CustomSelect'
import { OrderContext } from '../../../../utils/context'
import { arrayForSelect } from '../../../../utils/arrayForSelect'
import moment from 'moment'
import { getCourses } from '../../../../actions/common'


export default function Transfer() {

  const dispatch = useDispatch()

  const { values, personnelList, setFieldValue, handleChange, specFields } = useContext(OrderContext)

  useEffect(() => {
    dispatch(getCourses())
  }, [])

  return (
    <>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsRow}>
            <CustomSelect
              title='ФИО'
              valuesName="mid"
              options={arrayForSelect(personnelList, 'fio', 'mid')}
              value={personnelList && personnelList?.find(item => item.mid == values.mid)?.fio}
              setFieldValue={setFieldValue}
              withoutAll
              width={300}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              // error={values.date === '' ? 'Обязательное поле' : ''}
              type='date'
              label='Дата превода'
              name='date'
              value={moment(values.date).format('YYYY-MM-DD')}
              onChange={handleChange}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='На должность'
              name='string'
              value={values.string}
              // error={error('string2')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Оклад'
              name='money'
              type='number'
              value={values.num3}
              // error={error('name')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Основание'
              name='string2'
              value={values.string2}
              // error={error('string2')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
        </div>
      </div >

    </>
  )
}
